<div fxLayout="row" fxLayoutAlign="center end">
    <div class="block-player" *ngFor="let player of _players">
        <app-my-cash [cash]="player.cash" [assetIds]="player.assetIds" [playground]="_playground" [debt]="0" [player]="player"></app-my-cash>
    </div>
</div>
